import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Upload, notification } from 'antd'
import * as Icons from '@ant-design/icons'
import { loadJsonFile } from 'admin/lib/files'
import { getMatcher, useGlobalShortcut } from 'admin/lib/shortcuts'

function showError(message) {
  notification.error({
    message: 'Error when loading JSON',
    description: String(message)
  })
}

export function OpenJsonButton({ onOpen }) {
  const ref = useRef()

  useGlobalShortcut(
    getMatcher({ group: 'File', name: 'Load JSON' }, 'O', {
      ctrlOrCommand: true
    }),
    useCallback(() => {
      ref.current.click()
    }, [])
  )

  return (
    <Upload
      accept="application/json"
      beforeUpload={async file => {
        try {
          const data = await loadJsonFile(file)
          onOpen(data)
        } catch (error) {
          showError(error)
        }

        return false
      }}
      showUploadList={false}
    >
      <Button icon={<Icons.UploadOutlined />} ref={ref}>
        Open JSON
      </Button>
    </Upload>
  )
}

OpenJsonButton.propTypes = {
  onOpen: PropTypes.func.isRequired
}
